module.exports = __webpack_public_path__ + "static/media/iChlor.0d076804.jpg";